import * as React from 'react';
import {FieldProps} from 'formik';
import TextField from '@mui/material/TextField';

const BasicTextField: React.FC<FieldProps> = (props) => {
    const {form, field} = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        form.setFieldValue(field.name, event.target.value);
    };

    return (
        <TextField
            label="Sign here"
            variant="outlined"
            focused={true}
            value={field.value}
            sx={{
                marginTop: {xs: '20px', sm: '0'},
                marginBottom: {xs: '10px', sm: '10px', md: '20px'},
                boxSizing: 'initial',
            }}
            inputProps={{
                maxLength: '200',
            }}
            onChange={handleChange}
        />
    );
};

export default BasicTextField;
